












































































































import ModalCreatePreCollection from '@/main-components/question-generated/ModalCreatePreCollection.vue';
import {
  PaperGenerated,
  PaperGeneratedStatus,
} from '@/resource/paper-generated/paper-generated.model';
import { axios } from '@/utils/axios';
import { Component, Vue } from 'vue-property-decorator';
import getLevel from '@/utils/common/get-level';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';
import generatePrecollectionUrl from '@/utils/common/generate-precollection-url';

async function getAllPaperGenerated(): Promise<PaperGenerated[]> {
  const { data } = await axios.get('paper-generated/generated');
  return data;
}

async function getAllPaperOriginal(): Promise<PaperGenerated[]> {
  const { data } = await axios.get('paper-generated/original');
  return data;
}

async function publishPreCollection(
  preCollection: PreCollection,
): Promise<void> {
  await axios.put(`pre-collections/${preCollection.uuid}/publish`);
}

async function unpublishPreCollection(
  preCollection: PreCollection,
): Promise<void> {
  await axios.put(`pre-collections/${preCollection.uuid}/unpublish`);
}

async function deletePaperGenerated(
  paperGenerated: PaperGenerated,
): Promise<void> {
  await axios.delete(`/paper-generated/${paperGenerated.id}`);
}

@Component({
  components: { ModalCreatePreCollection },
})
export default class AdminGeneratedPapers extends Vue {
  isLoading = true;
  paperGenerateds: PaperGenerated[] = [];
  paperOriginals: PaperGenerated[] = [];
  openModalCreatePreCollection: any = null;
  selectedPaperGenerated: PaperGenerated | null = null;

  async created() {
    this.paperGenerateds = await getAllPaperGenerated();
    this.paperOriginals = await getAllPaperOriginal();
    this.isLoading = false;
  }

  paperGeneratedViewClicked(id: number) {
    this.$router.push(`/generated-papers/${id}`);
  }

  createPreCollectionClicked(paperGenerated: PaperGenerated) {
    this.selectedPaperGenerated = paperGenerated;

    if (!paperGenerated.preCollection) {
      this.openModalCreatePreCollection && this.openModalCreatePreCollection();
    }
  }

  async republishClicked(paperGenerated: PaperGenerated) {
    if (paperGenerated.preCollection) {
      this.$toasted.global.mainToast({
        message: 'Republish...',
      });

      await publishPreCollection(paperGenerated.preCollection);
      this.$router.go(0);
    }
  }

  async unpublishClicked(paperGenerated: PaperGenerated) {
    if (paperGenerated.preCollection) {
      this.$toasted.global.mainToast({
        message: 'Unpublish...',
      });

      await unpublishPreCollection(paperGenerated.preCollection);
      this.$router.go(0);
    }
  }

  liveClicked(preCollection: PreCollection) {
    const itemName = generatePrecollectionUrl(preCollection);

    const routeData = this.$router.resolve({
      path: `/browse/${itemName}`,
    });
    window.open(routeData.href, '_blank');
  }

  async deleteClicked(paperGenerated: PaperGenerated) {
    const isConfirm = confirm('Confirm Delete?');
    if (isConfirm) {
      this.$toasted.global.mainToast({
        message: 'Deleting...',
      });
      await deletePaperGenerated(paperGenerated);
      this.$router.go(0);
    }
  }

  openModalCreatePreCollectionAdd(openModal: any) {
    this.openModalCreatePreCollection = openModal;
  }

  getPaperGeneratedStatus(paperGenerated: PaperGenerated) {
    if (paperGenerated.preCollection) {
      if (paperGenerated.preCollection.isDraft) {
        paperGenerated.status = PaperGeneratedStatus.Pause;
      } else {
        paperGenerated.status = PaperGeneratedStatus.Published;
      }
    } else {
      paperGenerated.status = PaperGeneratedStatus.draft;
    }

    return paperGenerated.status;
  }

  getForm(paperGenerated: PaperGenerated) {
    return getLevel(paperGenerated.form);
  }
}
